import { render, staticRenderFns } from "./management-workspace-members-view.vue?vue&type=template&id=0f3dfa38&scoped=true&"
import script from "./management-workspace-members-view.vue?vue&type=script&lang=js&"
export * from "./management-workspace-members-view.vue?vue&type=script&lang=js&"
import style0 from "./management-workspace-members-view.vue?vue&type=style&index=0&id=0f3dfa38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3dfa38",
  null
  
)

export default component.exports